import React from 'react';
import '../css/navBar.css';
import Encabezado from './Encabezado';
import TablaActividades from './TablaActividades';

function MainActividades(){

    return(  
        <>  
            <div id="containerActividades" className='container container-width-85'>
                <Encabezado seccionId={3}/>      
                <TablaActividades/>
            </div>
        </>
    );
}


export default MainActividades;